import { styled } from '@mui/material';

export const StyledEmptyMessage = styled('div')`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
`;
